/**
 * Single rounded star glyph (Fresha-style). Used for the compact rating
 * chips in the hero/header — one filled star + the numeric average + count,
 * instead of a big five-star row.
 */
import React from 'react';

const FreshaStar = ({ size = 14, color = '#FFC00A', className, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill={color}
    aria-hidden="true"
    focusable="false"
    className={className}
    style={style}
  >
    <path d="m29.3 13.299-5.633 4.92 1.687 7.326a2 2 0 0 1-1.86 2.453 2 2 0 0 1-1.118-.285l-6.384-3.876-6.37 3.876a1.997 1.997 0 0 1-2.979-2.168l1.685-7.318-5.635-4.928A2 2 0 0 1 3.831 9.79l7.428-.644 2.9-6.92a1.994 1.994 0 0 1 2.943-.892c.327.218.582.528.734.891l2.908 6.921 7.425.644a1.998 1.998 0 0 1 1.757 2.531 2 2 0 0 1-.62.977z" />
  </svg>
);

export default FreshaStar;
